import React, { Component } from "react";
import style from "../../../assets/css/modules/containers/slidey-menu.css";

export default class SlideyMenu extends Component {
  listRef = React.createRef();
  state = {};

  checkSizesImpl = (menu, existingStroke, transition) => {
    let link =
      this.listRef.current &&
      menu !== undefined &&
      this.listRef.current.querySelector(`li > a[data-menu='${menu}']`);
    let strokeStyle;
    if (link) {
      let translate = `translate(${link.offsetLeft}px, 0)`;
      strokeStyle = {
        width: `${link.scrollWidth}px`,
        transform: translate,
        msTransform: translate,
        WebkitTransform: translate
      };
      if (!(existingStroke && existingStroke.width) || !transition) {
        strokeStyle.transition = "none";
      }
    } else {
      strokeStyle = {
        display: "none"
      };
    }
    if (
      !existingStroke ||
      (existingStroke.width !== strokeStyle.width ||
        existingStroke.transform !== strokeStyle.transform)
    ) {
      return strokeStyle;
    }
  };

  checkSizes() {
    let activeStrokeStyle = this.checkSizesImpl(
      this.props.selectedMenu,
      this.state.activeStrokeStyle,
      false
    );
    let highlightedStrokeStyle = this.checkSizesImpl(
      this.props.highlightedMenu,
      this.state.highlightedStrokeStyle,
      true
    );
    if (activeStrokeStyle || highlightedStrokeStyle) {
      let state = {};
      if (activeStrokeStyle) {
        state.activeStrokeStyle = activeStrokeStyle;
      }
      if (highlightedStrokeStyle) {
        state.highlightedStrokeStyle = highlightedStrokeStyle;
      }
      this.setState(state);
    }
  }

  componentDidMount() {
    this.checkSizes();
  }

  componentDidUpdate() {
    this.checkSizes();
  }

  render() {
    let children = this.props.children.map
      ? this.props.children
      : [this.props.children];
    return (
      <div ref={this.listRef} className={style.wrapper}>
        {children}
        <div
          key="navstroke"
          className={this.props.strokeStyle || style.navStroke}
          style={this.state.activeStrokeStyle}
        />
        <div
          key="highlightStroke"
          className={this.props.strokeStyle || style.navStroke}
          style={this.state.highlightedStrokeStyle}
        />
      </div>
    );
  }
}
